import React, { useMemo } from "react";
import { Paper, makeStyles, Switch } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AllConditions from "./allConditions";

import styles from "./styles";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(styles);

const DisplayPermissions = ({
  permissions,
  handleChange,
  recordType,
  editModeOn,
  changeInDefaultPermissions,
  displayConditions,
  condForNonEdit,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const actions = useMemo(
    () =>
      Object.keys(recordType.actions)
        .map((a) => recordType.actions[a])
        .filter((a) => !a.internal && !a.legacy),
    [recordType]
  );
  return (
    <TableContainer component={Paper} key={recordType.name}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerTop} align="center" colSpan="3">
              {t(`labels.accessControl.rule.recordTypes.${recordType.label}`)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.headerTop} align="left">
              {t("labels.accessControl.rule.table.headers.permission")}
            </TableCell>
            <TableCell className={classes.headerTop} align="center">
              {t("labels.accessControl.rule.table.headers.allowDeny")}
            </TableCell>
            <TableCell className={classes.headerTop} align="center">
              {t("labels.accessControl.rule.table.headers.conditions")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {actions.map((action) => {
            if (typeof permissions[recordType.name][action.name] === "string") {
              return;
            }
            let allowDeny;
            let allowDenyClass;
            if (editModeOn === false) {
              allowDeny =
                permissions[recordType.name][action.name]["accessStatus"] ===
                false
                  ? t("labels.accessControl.rule.deny")
                  : t("labels.accessControl.rule.allow");
              allowDenyClass =
                permissions[recordType.name][action.name]["accessStatus"] ===
                true
                  ? classes.greenBold
                  : permissions[recordType.name][action.name][
                      "accessStatus"
                    ] === false
                  ? classes.red
                  : classes.green;
            }
            return (
              <TableRow key={`${recordType.name}-${action.name}`}>
                <TableCell className={classes.rightBorder} width="30%">
                  {action.label || action.name}
                </TableCell>
                <TableCell
                  className={classes.rightBorder}
                  width="20%"
                  align="center"
                >
                  {editModeOn === false ? (
                    <span className={allowDenyClass}>{allowDeny}</span>
                  ) : (
                    <>
                      <span>{t("labels.accessControl.rule.deny")}</span>
                      <Switch
                        checked={
                          permissions[recordType.name][action.name][
                            "accessStatus"
                          ]
                        }
                        disableRipple
                        color="primary"
                        classes={{
                          switchBase: classes.switchBase,
                          thumb: classes.thumb,
                          track: classes.track,
                          checked: classes.checked,
                        }}
                        onChange={(event) =>
                          handleChange(
                            event,
                            "permissions",
                            action.name,
                            recordType.name
                          )
                        }
                      />
                      <span>{t("labels.accessControl.rule.allow")}</span>
                    </>
                  )}
                </TableCell>
                <TableCell align="center">
                  {editModeOn === false ? (
                    condForNonEdit &&
                    condForNonEdit[recordType.name] &&
                    condForNonEdit[recordType.name][action.name] &&
                    condForNonEdit[recordType.name][action.name].conditions ? (
                      displayConditions(
                        condForNonEdit[recordType.name][action.name].conditions
                      )
                    ) : (
                      t("labels.common.none")
                    )
                  ) : permissions &&
                    permissions[recordType.name] &&
                    permissions[recordType.name][action.name] &&
                    permissions[recordType.name][action.name].accessStatus ===
                      true ? (
                    <AllConditions
                      conditions={
                        permissions[recordType.name][action.name]["conditions"]
                      }
                      updatePermissions={changeInDefaultPermissions}
                      recordTypeName={recordType.name}
                      actionName={action.name}
                    />
                  ) : (
                    t("labels.common.none")
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default React.memo(DisplayPermissions);
